import { useState, useEffect } from 'react';
import { publicApi } from '@/lib/api';
import { FadeIn } from '@/components/FadeIn';
import { useContentValue } from '@/contexts/SiteContentContext';
import { Calendar, Loader2 } from 'lucide-react';

export default function EventsSection() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const c = useContentValue();

  useEffect(() => {
    publicApi.getEvents().then((res) => setEvents(res.data.events || []))
      .catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <section id="events" data-testid="events-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <FadeIn>
          <div className="text-center mb-16">
            <span className="text-amber-400 text-xs tracking-[0.3em] uppercase font-body">{c('Events.Eyebrow', 'Events')}</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-stone-100 mt-3 tracking-wide uppercase">{c('Events.Überschrift', 'Unvergessliche Momente')}</h2>
            <p className="text-stone-400 text-base max-w-lg mx-auto mt-4 font-body">
              {c('Events.Beschreibung', 'Ob Fussball, Geburtstag oder Firmenanlass — bei TreffPunkt wird jeder Abend zum Erlebnis.')}
            </p>
          </div>
        </FadeIn>
        {loading ? (
          <div className="flex justify-center py-16"><Loader2 size={32} className="text-amber-400 animate-spin" /></div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {events.map((event, i) => (
              <FadeIn key={event.id || i} delay={i * 120}>
                <div data-testid={`event-card-${i}`} className="group relative rounded-2xl overflow-hidden h-[320px] sm:h-[360px] img-zoom cursor-pointer">
                  <img src={event.image_url} alt={`${event.title} — Event im TreffPunkt Luzern`} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent group-hover:from-black/90 transition-all duration-500" />
                  <span className="absolute top-4 left-4 px-3 py-1 bg-amber-500/90 text-[#141413] text-xs font-body font-semibold rounded-full uppercase tracking-wider">{event.event_type}</span>
                  <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">
                    <h3 className="font-display text-2xl sm:text-3xl font-bold text-stone-100 mb-2 tracking-wide uppercase">{event.title}</h3>
                    <p className="text-stone-300 text-sm font-body leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 max-w-md">{event.description}</p>
                  </div>
                  <div className="absolute top-4 right-4 w-10 h-10 rounded-full glass-card flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <Calendar size={16} className="text-amber-400" />
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
